import React from "react";
import HalfScreenSection from "./HalfScreenSection";
import { Box, Center, Heading } from "@chakra-ui/react";
import Card from "./Card";

const projects = [
  {
    title: "Secure Online Transactions",
    description:
      "A secure and user-friendly platform for seamless online transactions, ensuring your payments are protected with advanced encryption and fraud detection technologies.",
    getImageSrc: () => require("../images/secureTransaction2.png"),
  },
  {
    title: "Fast Transfers",
    description:
      "Fast and on-time arrival of money transfers across borders, ensuring your funds reach their destination quickly and securely, every time.",
    getImageSrc: () => require("../images/fastMoney.png"),
  },
  {
    title: "Best Exchange Rates",
    description:
      `Competitive exchange rates, helping you get the most value for your money. Leverage our rate prediction AI 
      feature to find the optimal transfer window for maximum savings.`,
    getImageSrc: () => require("../images/rates.png"),
  },
];

const ProjectsSection = () => {
  return (
    <HalfScreenSection
      backgroundColor="rgba(255, 255, 255, 0.9)"
      isDarkBackground={false}
      p={8}
      spacing={8}
    >
      <Heading as="h1" id="projects-section" textAlign="center">
        Why Swiftchang for cross-border transfers?
      </Heading>
      <Box
        display="grid"
        gridTemplateColumns={{ base: "1fr", md: "repeat(2,minmax(0,1fr))", lg: "repeat(3,minmax(0,1fr))" }}
        gridGap={{ base: 6, md: 8 }}
        maxWidth="1100px"
        margin="0 auto"
      >
        {projects.map((project) => {
                  
          return (
            <Card
              key={project.title}
              title={project.title}
              description={project.description}
              imageSrc={project.getImageSrc()}
              textAlign="justify"
              imageHeight="230px"
             
            />
          );
        })}
      </Box>
    </HalfScreenSection>
  );
};

export default ProjectsSection;
